module.exports = __webpack_public_path__ + "assets/img/smartTV-icon2.69baacf3.png";